'use strict';

require('../shared/base-entry');
require('../header/views/main-menu');
require('../../components/alert_bar');
require('../redemption/views/redemption-provider-hoc');
require('../coupons/views/coupons-list-filter');
require('../../components/leaderboard_banner');
require('../coupons/views/coupons-filter');
require('../../components/carousel');
require('../shared/post-entry');
